export default __webpack_public_path__ + "static/media/qemotion_login-logo.3d2e85cf.png";